module.exports = __webpack_public_path__ + "static/media/quote3.56f76ab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/quote3.png
// module id = 63
// module chunks = 0